import React from 'react';

import './FileTable.scss';

const FileTable = () => {
  return <div></div>;
};

export default FileTable;
